var img = "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'%3e%3cpath d='M0 0h5v3H0z'/%3e%3cpath fill='%23D00' d='M0 1h5v2H0z'/%3e%3cpath fill='%23FFCE00' d='M0 2h5v1H0z'/%3e%3c/svg%3e";
  export default img;